<template>
    <modal @close="closeModal" dusk="delete-server">
        <div class="u-margin-bottom">
            {{
                trans('confirm.delete-entity', {
                    entity: this.server.display_name
                })
            }}
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray btn-ghost--vps | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record btn-ghost--vps" type="submit" @click="destroyServer">
                {{ trans('action.delete') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { EventBus } from 'relapp-event';
import { Modal } from 'relapp-modal';
import {ServicesApi} from "../../../technical-management";
import {Way2Form} from "relapp-way2forms/src/way2forms";

export default {
    components: {
        Modal
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        server: Object,
        subscriptions: {
            type: Array,
            default: null
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        let serverId = function () {
            return this.server.subscription_id;
        }
        let getSubscriptionId = serverId.bind(this);

        return {
            serviceCancelForm: new Way2Form({
                subscriptions: this.subscriptions.filter(function (subscription) {
                    return (subscription.type === 'vps' && subscription.uuid === getSubscriptionId());
                }).map(subscription => {
                    return {
                        type: subscription.type,
                        uuid: subscription.uuid,
                        cancel: false,
                        cancel_immediately: true,
                        transfer: false
                    };
                })
            }),
            isLoading: false
        };
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Destroy server
         */
        destroyServer() {
            ServicesApi.cancel({ form: this.serviceCancelForm })
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.deleted')
                    });

                    this.$parent.removeServerFromList(this.server.id);
                    this.serviceCancelForm.reset();
                    this.$emit('close');
                    this.$router.push({ name: 'vpsOverview', params: { domain: this.domain } });
                })
                .catch(error => {
                    this.handleError(error);
                });
        }
    }
};
</script>
